import React from 'react';
import { useTranslation } from 'react-i18next';

import DirectOrder from '../DirectOrder/DirectOrder';

import EmptyBasket from 'assets/img/empty-basket.png';

import styles from './CartWithoutProduct.module.scss';

export default function CartWithoutProduct(): JSX.Element {
  const { t } = useTranslation(['checkout']);

  return (
    <div className={styles.container}>
      <h1>{t('CART_YOUR_BASKET_IS_EMPTY')}</h1>
      <img src={EmptyBasket} alt="empty-basket" />
      <p>{t('CART_YOUR_BASKET_IS_EMPTY_HELPING_TEXT')}</p>
      <DirectOrder classes={{ container: styles.directOrderContainer }} />
    </div>
  );
}
